import { ApplicationConfig, inject, provideZoneChangeDetection, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';

import { Breakpoints } from '@angular/cdk/layout';

import { ErrorInterceptor, PwaService, PWA_CONFIG } from '@public/core';
import { Sidenav, SIDENAV_CONFIG } from '@public/core/ui/sidenav';
import { Toolbar } from '@public/core/ui/toolbar';

import { environment } from '../environments/environment';

import { SidenavContentComponent, ToolbarContentComponent } from './components';

import { routes } from './root.routes';

const initSidenav = () => {
  const sidenav = inject(Sidenav);
  sidenav.content = SidenavContentComponent;
};

const initToolbar = () => {
  const toolbar = inject(Toolbar);
  toolbar.content = ToolbarContentComponent;
};

const initPwaService = () => {
  const pwaService = inject(PwaService);
};

export const rootConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideServiceWorker('/ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
    provideAppInitializer(initToolbar),
    provideAppInitializer(initSidenav),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: SIDENAV_CONFIG,
      useValue: [Breakpoints.Handset, Breakpoints.TabletPortrait],
    },

    // PWA configuration. PWA_CONFIG value must be provided before the corresponding App Initializer.

    {
      provide: PWA_CONFIG,
      useValue: {
        installPrompt: {
          promptText: 'Ønsker du at installere dette website som en app?',
          buttonText: 'Ja tak!',
        },
        updatePrompt: {
          promptText: 'En ny og forbedret udgave er tilgængelig.',
          buttonText: 'Installér og genindlæs',
        },
        timeout: 10000,
      },
    },
    provideAppInitializer(initPwaService),
  ],
};
